import {Component, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {RevenueRestService} from '../../../../core/services/api/revenue-rest.service';
import {UserService} from '../../../../core/services/user.service';
import {takeUntil} from 'rxjs/operators';
import {Observable, Subject} from 'rxjs';
import {RevenueResponseInterface} from './interface/revenue-response.interface';
import {GlobalConstants} from '../../../../core/constants/global.constants';
import {jsPDF} from 'jspdf';
import {MatTabGroup} from '@angular/material/tabs';



@Component({
  selector: 'my-sales',
  templateUrl: './my-sales.component.html',
  styleUrls: ['./my-sales.component.scss']
})
export class MySalesComponent implements OnInit, OnDestroy {
  public revenue: RevenueResponseInterface;
  public idfs$: Observable<any[]>;
  public currentlyDisplayedIdf: string;
  public options;
  public chart;
  public echartsInstance;
  public echartsInstancePkp;
  public loading = true;
  public ngUnsubscribe$ = new Subject<any>();
  public input = false;
  public mainIdf: string;
  public today: Date = new Date();
  public digitalPaket = false;
  @ViewChild('tabGroup') tabGroup: MatTabGroup;
  private scrollPosition = 0;
  private scrollHandler: any;


  constructor(@Inject(RevenueRestService) public revenueApiService: RevenueRestService,
              @Inject(UserService) public userService: UserService,
              @Inject(GlobalConstants) public contants: GlobalConstants) {
    this.input = true;
    this.digitalPaket = this.userService.isDigitalPaket();
    this.currentlyDisplayedIdf = '9999910';
    this.mainIdf = '9999910';
    this.fakeGraph(this.currentlyDisplayedIdf);
    this.fakeGraphPkp(this.currentlyDisplayedIdf);
    this.scrollHandler = () => {
      this.scrollPosition = window.scrollY;
    };
  }


  ngOnInit() {
    this.loadRevenue(this.currentlyDisplayedIdf);

  }

  ngAfterViewInit() {
    window.addEventListener('scroll', this.scrollHandler);

    if (this.tabGroup) {
      this.tabGroup.selectedIndexChange.subscribe((index) => {
        const currentPosition = this.scrollPosition;

        setTimeout(() => {
          window.scrollTo({
            top: currentPosition,
            behavior: 'auto'
          });
        }, 10);
      });
    } else {
      console.warn('tabGroup is not defined in ngAfterViewInit');
    }
  }

  public loadRevenue(idf: string) {

    if (idf === this.contants.DUMMY_IDF) {
      this.fakeGraph(idf);
      return;
    }
  }

  /**
   * Unsubscribe from all subscriptions.
   */
  ngOnDestroy() {
    window.removeEventListener('scroll', this.scrollHandler);
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  formatYAxisLabel(value) {
    return value.toLocaleString('de-DE') + '€';
  }

  formatTooltip(params, ticket, callback) {
    let res = params[0].name;
    for (let i = 0, l = params.length; i < l; i++) {
      res += '<br/>' + params[i].marker + params[i].seriesName + ': ' + params[i].value.toLocaleString('de-DE') + '€';
    }
    return res;
  }

  formatIdf(idf) {
    return ('0000000' + idf).slice(-7);
  }

  dataEmpty(series) {
    for (const data of series) {
      if (data.data.length) {
        return false;
      }
    }
    return true;
  }

  fakeGraph(idf) {
    this.options = {
      title: {
        textStyle: {
          color: '#393938', fontFamily: 'Roboto Light', fontSize: 24
        }
      },
      color: [
        '#009775',
        '#92d400',
        '#393938',
        '#999999',
        '#91c7ae',
        '#749f83',
        '#92d400',
        '#bda29a',
        '#009775',
        '#999999',
        '#c4ccd3'
      ],
      tooltip: {
        trigger: 'axis',
        formatter: this.formatTooltip
      },
      legend: {
        data: [
          {
            name: 'Non-RX-Umsatz',
            icon: 'circle',
            backgroundColor: '#92d400'
          }
          ,
          {
            name: 'RX-Umsatz inkl HP',
            icon: 'circle',
            backgroundColor: '#009775'
          },
          {
            name: 'HP-Umsatz',
            icon: 'circle',
            backgroundColor: '#535353'
          }
        ],
        bottom: 0,
        left: 80,
        itemGap: 35
      },
      grid: {
        left: '3%',
        right: '3%',
        bottom: '10%',
        top: '20%',
        containLabel: true,
      },
      xAxis: {
        axisLabel: {
          fontSize: 16,
          fontFamily: 'Roboto Light',
          color: '#999999',
          padding: [25, 0, 0, 0],
        },
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        type: 'category',
        boundaryGap: false,
        data: ['06/24', '07/24', '08/24', '09/24', '10/24', '11/24', '12/24', '01/25', '02/25', '03/25', '04/25', '05/25', '06/25', '07/25', '08/25', '09/25'],
        padding: [0, 30, 0, 0]
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: this.formatYAxisLabel,
          fontSize: 16,
          fontFamily: 'Roboto Light',
          color: '#999999',
          padding: [0, 15, 5, 0],
        },
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
      },
      series: [
        {
          name: 'Non-RX-Umsatz',
          type: 'line',
          data: [120, 132, 101, 134, 90, 230, 210, 120, 132, 101, 134, 90, 210, 120, 132, 101],
        },
        {
          name: 'RX-Umsatz inkl HP',
          type: 'line',
          data: [220, 182, 0, 234, 290, 330, 310, 220, 0, 191, 234, 290, 234, 290, 330, 310],
        },
        {
          name: 'HP-Umsatz',
          type: 'line',
          data: [320, 332.32, 301, 334, 390, 330, 320, 320, 332, 301, 334, 390, 332.32, 301, 334, 390],
        }
      ]
    };

    this.revenue = {chart: null, month: '', totalRevenue: null, rxPacketValue: null, rxSpanPercent: null};
    this.revenue.totalRevenue = 100;
    const now = new Date();

    this.revenue.month = String(new Date(now.getFullYear(), now.getMonth(), now.getDate()).toLocaleString('de', {month: 'long'}));

    this.loading = false;
  }

  onChartInitPkp(ec: any) {
    this.echartsInstancePkp = ec;
  }

  downloadChart() {
    const doc = new jsPDF();

    const imgData = this.echartsInstance.getDataURL({
      pixelRatio: 2,
      backgroundColor: '#fff'
    });

    doc.addImage(imgData, 'PNG', 15, 40, 175, 75);
    doc.save(`Monatlicher Umsatzverlauf der IDF ${this.currentlyDisplayedIdf}.pdf`);
  }

  fakeGraphPkp(idf) {
    this.options = {
      title: {
        textStyle: {
          color: '#393938', fontFamily: 'Roboto Light', fontSize: 24
        }
      },
      color: [
        '#009775',
        '#92d400',
        '#393938',
        '#999999',
        '#91c7ae',
        '#749f83',
        '#92d400',
        '#bda29a',
        '#009775',
        '#999999',
        '#c4ccd3'
      ],
      tooltip: {
        trigger: 'axis',
        formatter: this.formatTooltip
      },
      legend: {
        data: [
          {
            name: 'PKP Brutto-Umsatz',
            icon: 'circle',
            backgroundColor: '#92d400'
          }
          ,
          {
            name: 'PKP RX-Umsatz',
            icon: 'circle',
            backgroundColor: '#009775'
          },
          {
            name: 'PKP Non-RX-Umsatz',
            icon: 'circle',
            backgroundColor: '#535353'
          }
        ],
        bottom: 0,
        left: 80,
        itemGap: 35
      },
      grid: {
        left: '3%',
        right: '3%',
        bottom: '10%',
        top: '20%',
        containLabel: true,
      },
      xAxis: {
        axisLabel: {
          fontSize: 16,
          fontFamily: 'Roboto Light',
          color: '#999999',
          padding: [25, 0, 0, 0],
        },
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        type: 'category',
        boundaryGap: false,
        data: ['06/24', '07/24', '08/24', '09/24', '10/24', '11/24', '12/24', '01/25', '02/25', '03/25', '04/25', '05/25', '06/25', '07/25', '08/25', '09/25'],
        padding: [0, 30, 0, 0]
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: this.formatYAxisLabel,
          fontSize: 16,
          fontFamily: 'Roboto Light',
          color: '#999999',
          padding: [0, 15, 5, 0],
        },
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
      },
      series: [
        {
          name: 'PKP Brutto-Umsatz',
          type: 'line',
          data: [37133.41,46155.55,28106.8,42680.52,45203.13,42764.84,43908.21,42492.5,36590.34,43731.79,40711.66,36269.88,51626.78,39061.21,35300.15,44154.18],
        },
        {
          name: 'PKP RX-Umsatz',
          type: 'line',
          data: [15542.5,23310.98,9568.36,19368.98,25671.08,20500.46,20850.44,20878.09,13057.82,20524.92,21095.73,14906.4,30062.73,18953.11,16228.96,21163.45],
        },
        {
          name: 'PKP Non-RX-Umsatz',
          type: 'line',
          data: [21590.91,22844.57,18538.44,23311.54,19532.05,22264.38,23057.77,21614.41,23532.52,23206.87,19615.93,21363.48,21564.05,20108.1,19071.19,22990.73],
        }
      ]
    };

    this.revenue = {chart: null, month: '', totalRevenue: null, rxPacketValue: null, rxSpanPercent: null};
    this.revenue.totalRevenue = 100;
    const now = new Date();

    this.revenue.month = String(new Date(now.getFullYear(), now.getMonth(), now.getDate()).toLocaleString('de', {month: 'long'}));

    this.loading = false;
  }

  onChartInit(ec) {
    this.echartsInstance = ec;
  }

  onTabChange() {
    this.scrollPosition = window.scrollY;
  }

  loadRevenues(date) {
    this.onTabChange();
    switch (date.index) {
      case 0:
        this.loadRevenue(this.currentlyDisplayedIdf);
        break;
      case 1:
        this.loadPkpRevenue(this.currentlyDisplayedIdf);
        break;
    }
  }

  public loadPkpRevenue(idf: string) {
    if (idf === this.contants.DUMMY_IDF) {
      this.fakeGraphPkp(idf);
      return;
    }
  }
}
